import { ReactNode } from 'react'
import { CourseUser } from 'graphqlAPI'

export type Column = {
  title: ReactNode
  key:
    | keyof CourseUser
    | 'action'
    | 'advance'
    | 'enrol_overall_progress'
    | 'user_name'
    | 'area_name'
    | `synchronous_course_evaluations_${number}`
    | 'synchronous_course_enrol_attendance'
    | 'live_session_attendance_percent'
    | 'synchronous_course_enrols_final_state'
    | 'enrol_integration_status'
    | 'state_evaluations'
  dataIndex?: string
  sorteable?: boolean
  width?: number
  hideable?: boolean
  className?: string
  align?: 'left' | 'center' | 'right'
  fixed?: 'left' | 'right' | boolean
  render?: (data: any, courseUser: CourseUser) => any
}

export const ACTION_COLUMN_WIDTH = 45
export const CHECKBOX_COLUMN_WIDTH = 48
export const NAME_COLUMN_WIDTH = 260
export const AREA_COLUMN_WIDTH = 200
